module.exports = __webpack_public_path__ + "static/media/400032_01.4295c9db.png";